import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#737373",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M2.017 10.595c-.114-.18-.17-.27-.202-.409a1 1 0 0 1 0-.372c.032-.138.088-.228.202-.408.938-1.485 3.73-5.239 7.983-5.239 4.255 0 7.046 3.754 7.984 5.239.113.18.17.27.202.408a1 1 0 0 1 0 .373c-.032.138-.089.228-.202.408-.938 1.485-3.73 5.239-7.984 5.239s-7.045-3.754-7.983-5.24"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#737373",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    }, null, -1)
  ])))
}
export default { render: render }